/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const Container = styled.div`
  position: ${(props) => (props.sticky ? 'sticky' : 'relative')};
  top: ${(props) => (props.sticky ? '144px' : '0')};
  width: 341px;
  max-width: 100%;

  & > div:first-child {
    margin-top: 0;
  }

  & > div:nth-child(n + 2) {
    margin-top: 10px;
  }

  .darkmode {
    background-color: var(--titan-blue-6) !important;
    .email-logo {
      display: block;
      margin: 0px auto 30px;
    }
    .email-title {
      text-align: center;
      margin: 0px !important;
    }
    .email-title:last-child {
      margin: 0 0 15px 0 !important;
    }
    .email-subhead {
      text-align: center;
    }
    .signup-form--form {
      background-color: var(--titan-blue-6) !important;
    }

    .react-reveal {
      a {
        color: white !important;
        font-weight: 800;

        &:hover {
          color: white !important;
          text-decoration-color: white !important;
        }
      }
    }

    p,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    span {
      color: white !important;
    }
  }

  .sidebar--subscribe-marketo-legal-info {
    p {
      font-size: var(--font-size-13);
    }
  }
  @media (max-width: 1199px) {
    width: 100%;
  }
`;
